// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-salepage-action .v-list-item--disabled .v-list-item__subtitle {\n  color: #B1B1B1;\n}\n", ""]);
// Exports
module.exports = exports;
